<template>
  <div>
    <v-dialog
      v-model="addEditDialog"
      persistent
      max-width="500px"
      transition="slide-y-transition"
    >
      <v-card class="dialog-card-border">
        <v-card-title class="text-h6 font-weight-light">
          {{ editMode ? $t('Update Balance Transfer') : $t('Add New Balance Transfer') }}
        </v-card-title>

        <validation-observer
          ref="theForm"
          v-slot="{ handleSubmit, reset }"
        >
          <form
            autocomplete="off"
            @submit.prevent="handleSubmit(submit)"
            @reset.prevent="reset"
          >
            <v-card-text>
              <v-row no-gutters>
                <v-col
                  class="px-2 text-h6 mb-6 font-weight-bold warning--text"
                  cols="12"
                >
                  {{ $t('From Customer Balance') }}: {{ $_format_number(formData.customer_balance) }}
                </v-col>

                <v-col
                  class="px-1"
                  sm="12"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('From Customer')"
                    rules="required"
                  >
                    <v-autocomplete
                      v-model="formData.from_customer_id"
                      :label="`* ${$t('From Customer')}`"
                      :items="customersList"
                      :item-text="item => `${item.name} | ${item.phone1}`"
                      :item-value="item => item.id"
                      outlined
                      dense
                      :color="$_input_color()"
                      :error-messages="errors"
                      @input="fromCustomerSelected(formData.from_customer_id)"
                    />
                  </validation-provider>
                </v-col>

                <v-col
                  class="px-1"
                  sm="12"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('To Customer')"
                    rules="required"
                  >
                    <v-autocomplete
                      v-model="formData.to_customer_id"
                      :label="`* ${$t('To Customer')}`"
                      :items="customersList"
                      :item-text="item => `${item.name} | ${item.phone1}`"
                      :item-value="item => item.id"
                      outlined
                      dense
                      :color="$_input_color()"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>

                <v-col
                  class="px-1"
                  cols="12"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('Amount')"
                    rules="required"
                  >
                    <v-currency-field
                      v-model="formData.amount"
                      :label="`* ${$t('Amount')}`"
                      outlined
                      dense
                      disabled
                      :color="$_input_color()"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>

                <v-col
                  class="px-1"
                  cols="12"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('Note')"
                  >
                    <v-textarea
                      v-model="formData.note"
                      :label="$t('Note')"
                      outlined
                      dense
                      rows="3"
                      :color="$_input_color()"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>

                <v-col
                  class="px-1"
                  cols="12"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('Amount')"
                    rules="required"
                  >
                    <app-date-picker
                      v-model="formData.action_date"
                      :label="`* ${$t('Date')}`"
                      no-title
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions class="py-3">
              <app-form-tip />

              <v-spacer />

              <v-btn
                depressed
                outlined
                small
                @click="closeDialog()"
              >
                {{ $t('Cancel') }}
              </v-btn>

              <app-submit-button :edit-mode="editMode" />
            </v-card-actions>
          </form>
        </validation-observer>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  props: {
    addEditDialog: { type: Boolean, default: false },
    formData: { type: Object, default: () => { } },
    editMode: { type: Boolean, default: false },
  },

  computed: {
    ...mapGetters(['customersList']),
  },

  methods: {
    fromCustomerSelected(id) {
      axios.get(`customer/${id}/get-balance/`).then(res => {
        this.formData.customer_balance = res.data.balance
        this.formData.amount = res.data.balance
      })
    },

    closeDialog() {
      this.$refs.theForm.reset()
      this.$emit('close')
    },

    submit() {
      if (this.editMode) {
        axios.put(`balance-transfer/${this.formData.id}/`, this.formData).then(() => {
          this.$_notify('Updated successfully')
          this.closeDialog()
          this.$emit('update-table-data')
        })
      } else {
        axios.post('balance-transfer/', this.formData).then(() => {
          this.$_notify('Added successfully')
          this.closeDialog()
          this.$emit('reset-table-data')
        })
      }
    }
  },
}
</script>
